export default __webpack_public_path__ + "Next-icon.svg";